import { render, staticRenderFns } from "./Professional.vue?vue&type=template&id=6ff76d8c&scoped=true&"
import script from "./Professional.vue?vue&type=script&lang=js&"
export * from "./Professional.vue?vue&type=script&lang=js&"
import style0 from "./Professional.vue?vue&type=style&index=0&id=6ff76d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff76d8c",
  null
  
)

export default component.exports